import { Link } from "react-router-dom";
import { cn } from "../lib/utils";

export function Logo({ className, asLink = true }) {
  const inner = (
    <span
      className={cn(
        "inline-flex items-baseline gap-1 select-none",
        "font-display tracking-[-0.02em]",
        className,
      )}
      data-testid="brand-logo"
    >
      <span className="text-[#D4AF37] text-xl sm:text-2xl font-semibold">Nexa</span>
      <span className="text-white text-xl sm:text-2xl font-semibold">lytics</span>
      <span className="ml-1 h-1.5 w-1.5 rounded-full bg-[#1E40AF] shadow-[0_0_10px_rgba(30,64,175,0.9)]" />
    </span>
  );
  return asLink ? (
    <Link to="/" className="no-underline">
      {inner}
    </Link>
  ) : (
    inner
  );
}

export default Logo;
